export default __webpack_public_path__ + "static/media/image3.c08818aa.png";